"use client"

import { useMemo } from "react"

import { useActiveBranchSlug } from "@/features/auth/hooks/use-active-branch-slug"
import { useBranchContextOverride } from "@/features/auth/hooks/use-branch-context-override"
import { useShowMultiBranchWorkspaceUi } from "@/features/auth/hooks/use-show-multi-branch-workspace-ui"
import { useUserBranchAccess } from "@/features/auth/hooks/use-user-branch-access"
import { getTenantFormBranchContext } from "@/features/auth/lib/form-branch-context"

export function useFormBranchContext() {
  const override = useBranchContextOverride()
  const activeBranchSlug = useActiveBranchSlug()
  const showMultiBranchWorkspaceUi = useShowMultiBranchWorkspaceUi()
  const { accessibleBranches } = useUserBranchAccess()

  return useMemo(() => {
    const base = getTenantFormBranchContext({
      accessibleBranches,
      activeBranchSlug,
      showMultiBranchWorkspaceUi,
    })
    // Branch Details console: the inspected branch isn't in accessibleBranches, so inject its id/slug directly.
    if (override) {
      return { ...base, activeBranchId: override.branchId, activeBranchSlug: override.branchSlug }
    }
    return base
  }, [accessibleBranches, activeBranchSlug, showMultiBranchWorkspaceUi, override])
}
